import { store } from '../store'
import axios from 'axios'

export default async (from, to, next) => {
  try{
    let logout = await axios.post('/api/auth/logout', null, { headers: {
        'Authorization': `Bearer ${store.getters.GET_TOKEN}`
      }
    })
    store.commit('RESET_STORE')
    // store.dispatch('LOGGED_OUT')
    next('/')
  }catch(e){
    console.log(e)
    store.commit('RESET_STORE')
    // store.dispatch('LOGGED_OUT')
    next('/')
  }
}


// WEBPACK FOOTER //
// ./src/router/logout.js